<template>
  <div>
    <!-- <img src="https://yingedu-deep-agent.ksbao.com/practicenurse/mps.png" alt="" style="width: 25px;height:24px;vertical-align: middle;margin-right:5px;"> -->
    <div id="jsmind_container" @click="toclick"></div>
  </div>
</template>

<script>
import { getMindMapping } from "../api/api";
import "jsmind/style/jsmind.css";
import jsMind from "jsmind/js/jsmind.js";
require("jsmind/js/jsmind.draggable.js");
require("jsmind/js/jsmind.screenshot.js");
export default {
  data() {
    return {
      mind: {
        /* 元数据，定义思维导图的名称、作者、版本等信息 */
        meta: {
          name: "思维导图",
          author: "",
          version: "0.2",
        },
        /* 数据格式声明 */
        format: "node_tree",
        /* 数据内容 */
        data: {},
      },
      options: {
        container: "jsmind_container", // [必选] 容器的ID
        editable: true, // [可选] 是否启用编辑
        theme: "asbestos", // [可选] 主题, // [可选] 主题
        // primary
        // warning
        // danger
        // success
        // info
        // greensea
        // nephrite
        // belizehole
        // wisteria
        // asphalt
        // orange
        // pumpkin
        // pomegranate
        // clouds
        // asbestos
        view: {
          engine: "canvas", // 思维导图各节点之间线条的绘制引擎
          hmargin: 0, // 思维导图距容器外框的最小水平距离
          vmargin: 50, // 思维导图距容器外框的最小垂直距离
          line_width: 3, // 思维导图线条的粗细
          line_color: "#FFDB00", // 思维导图线条的颜色
        },
        layout: {
          hspace: 200, // 节点之间的水平间距
          vspace: 20, // 节点之间的垂直间距
          pspace: 20, // 节点与连接线之间的水平间距（用于容纳节点收缩/展开控制器）
        },
        shortcut: {
          enable: false, // 是否启用快捷键 默认为true
        },
        support_html: true, // 是否支持节点里的HTML元素
      },
    };
  },
  mounted() {
    var data = {
      appEName: this.$route.query.appEName,
      guid: this.$route.query.guid,
      userID: this.$route.query.userID,
    };
    this.deviceType = this.$route.query.deviceType;
    getMindMapping(data).then((res) => {
      this.mind.data = res.data.data.children[this.$route.query.index];
      this.jm = jsMind.show(this.options, this.mind);
      this.jm.expand_node(this.$route.query.ids);
      console.log(res.data.data.children);
      var array = res.data.data.children[0].children;
      for (let index = 0; index < array.length; index++) {
        console.log(array[index].id);
        var id = array[index].id;
        this.jm.set_node_color(id, "#f2f2f2", "");
      }
    });
  },
  methods: {
    toclick() {
      this.jm.disable_edit();
      if (this.jm.get_selected_node() == null) {
        return;
      }
      // console.log('this.jm.get_selected_node()',this.jm.get_selected_node().children)
      console.log(
        "this.jm.get_selected_node()1111",
        this.jm.get_selected_node()
      );
      var cdshow = this.jm.get_selected_node().children; //判断是否是最后一级
      var list = this.jm.get_selected_node(); //获取当前节点的数据
      // return;

      //判断是否是展开的展开的就关闭否则就展开
      if (list.expanded == true) {
        this.jm.toggle_node(list.id);
      } else {
        this.jm.expand_node(list.id);
      }

      if (cdshow.length == 0) {
        var cptID = list.parent.id; //获取父级id
        var parentid = list.parent.parent.id; //获取父级的父级id
        console.log("我进来了", window.webkit);
        //判断是否是ios
        if (this.deviceType == "ios") {
          window.webkit.messageHandlers.test.postMessage({
            cptID: cptID,
            parentid: parentid,
            id: list.id,
          });
        }
        //判断是否是android
        if (this.deviceType == "android") {
          window.android.onClickMap(
            list.parent.parent.id, //父级底下子级下标
            list.parent.id, //父级下标
            list.id
          );
        }
        //跳转小程序
        if (this.deviceType == "wx") {
          wx.miniProgram.navigateTo({
            url: `/pages/home/knowledge/knowledge?ID=${cptID}&parentid=${parentid}`,
          });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
#jsmind_container {
  width: 100vw;
  height: 100vh;
}
.imgs {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-right: 30px;
}
</style>
